module.exports = __webpack_public_path__ + "static/media/page_separator.aad76766.svg";